// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1Z2-R","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__RAKL-"};